import React from "react";
import { ArrowUp, Linkedin, Instagram, Facebook } from "lucide-react";
import { OdtWordmark } from "./OdtLogo";
import "./Footer.css";

// Kept in sync with the "sameAs" array in public/index.html JSON-LD.
const socialLinks = [
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/oddtive/",
    Icon: Linkedin,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/oddtive/",
    Icon: Instagram,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/people/Oddtive-Media-Productions/61584402436227/",
    Icon: Facebook,
  },
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <OdtWordmark className="footer-logo-mark" />
            </div>
            <p className="footer-tagline">
              Unconventional vision. Unrivaled impact.
            </p>
            {/* Kept in sync with "address" / "telephone" in public/index.html JSON-LD */}
            <address className="footer-address">
              <span className="footer-address-line">
                AK Heights, MR-2, Gate 1, B-17
              </span>
              <span className="footer-address-line">Islamabad, Pakistan</span>
              <a href="tel:+923295929752" className="footer-link footer-phone">
                +92 329 5929752
              </a>
            </address>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-list">
                <li>
                  <a href="#pricing" className="footer-link">
                    Social Media Campaigns
                  </a>
                </li>
                <li>
                  <a href="#pricing" className="footer-link">
                    Video Production
                  </a>
                </li>
                <li>
                  <a href="#pricing" className="footer-link">
                    Brand Strategy
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-list">
                <li>
                  <a href="#story" className="footer-link">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#contact" className="footer-link">
                    Contact
                  </a>
                </li>
                <li>
                  <a href="mailto:oddtive@gmail.com" className="footer-link">
                    oddtive@gmail.com
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:oddtive@gmail.com?subject=Careers%20at%20Oddtive"
                    className="footer-link"
                  >
                    Careers
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-heading">Follow</h4>
              <ul className="footer-list">
                {socialLinks.map(({ name, href, Icon }) => (
                  <li key={name}>
                    <a
                      href={href}
                      className="footer-link footer-social-link"
                      target="_blank"
                      rel="me noopener noreferrer"
                    >
                      <Icon size={16} aria-hidden="true" />
                      <span>{name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Oddtive. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="footer-back-to-top"
            aria-label="Back to top"
          >
            <span>Back to Top</span>
            <ArrowUp size={18} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;